<template>
  <div>
    <b-card title="Editar Personas">
      <div class="d-flex justify-content-center flex-wrap">
        <b-form-group>
          <b-input-group>
            <b-button
              variant="outline-primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :to="{
                name: 'persons',
                params: { idEvent: body.fkid_mxs_event },
              }">
              <feather-icon
                icon="ArrowLeftCircleIcon"
                class="mr-0 mr-sm-50"></feather-icon>
              Volver Atrás
            </b-button>
          </b-input-group>
        </b-form-group>
      </div>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-tabs content-class="mt-2" pills>
            <b-tab>
              <template #title>
                <feather-icon icon="FileTextIcon" />
                <span>Detalles Personas</span>
              </template>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Id Documento Acreditación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.pkid_accreditation_document_detail"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <h4>Tipo Procceso Acreditación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.fkid_accreditation_process_type"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <h4>Id Evento</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.fkid_mxs_event"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Temporada</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Temporada[0]"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <h4>Nombre Aforo</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Aforo_name"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <h4>Nombre Evento</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.event_name"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Acreditación Localizador</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.accreditation_localitzador[0]"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Método Creación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.metode_creacio"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Nombre"
                      rules="required">
                      <h4>Nombre</h4>
                      <b-form-input
                        id="input-default"
                        size="lg"
                        v-model="body.Nom_titular"
                        :plaintext="togglePlaintext"
                        required
                        :state="errors.length > 0 ? false : null" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Apellido1"
                      rules="required">
                      <h4>Apellido1</h4>
                      <b-form-input
                        id="input-default"
                        size="lg"
                        v-model="body.Cognom1_titular"
                        :plaintext="togglePlaintext"
                        required
                        :state="errors.length > 0 ? false : null" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Apellido2</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Cognom2_titular"
                      :plaintext="togglePlaintext" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>DOI</h4>
                    <b-form-select
                      size="lg"
                      v-model="body.DOI_Type"
                      :options="dniOptions"
                      :disabled="dateDisabled" />
                      <validation-provider v-if="body.DOI_Type === 'DNI'" #default="{ errors }" name="DOI" rules="required|dni" >                      
                      <b-form-input
                        v-if="body.DOI_Type === 'DNI'"
                        id="input-default"
                        size="lg"
                        maxlength="9"
                        v-model="body.DNI"
                        :plaintext="togglePlaintext" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <validation-provider
                      v-if="body.DOI_Type === 'Other'"
                      #default="{ errors }"
                      name="DOI"
                      rules="required">
                      <b-form-input
                        size="lg"
                        :plaintext="togglePlaintext"
                        v-model="body.DNI" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Teléfono</h4>
                    <b-form-input
                      id="input-telefon"
                      v-model="body.telefon"
                      maxLength="12"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Acceso SCA</h4>
                    <b-form-select
                      size="lg"
                      v-model="body.AccesSCA"
                      :options="dooraccesoptions"
                      :disabled="dateDisabled" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Estado Documento</h4>
                    <b-form-select
                      size="lg"
                      v-model="docStatusSelected"
                      :options="docStatusOptions"
                      @change="configureDocStatus()"
                      :disabled="dateDisabled" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Nombre Empresa</h4>
                    {{ body.Empresa_nom }}
                    <b-form-select
                      size="lg"
                      v-model="companySeleceted"
                      :options="companies"
                      @change="configureComany()"
                      :disabled="dateDisabled" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>estado Documento SCA</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.DocStatusSCA"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Código de Barras (Pulsera)</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Cod_Barras"
                      :plaintext="togglePlaintext" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Email</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.email"
                      :plaintext="togglePlaintext" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Fecha Nacimiento</h4>
                    <flat-pickr
                      v-model="body.Data_neixament"
                      class="form-control"
                      :disabled="dateDisabled" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Actualizar NombreArchivo</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.UploadFilename"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Id Usuario Modificación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.ID_usuari_modificacio"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row class="justify-content-center">
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Fecha Creación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.timestamp_creacio"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Fecha Modificación</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.timestamp_modificacio"
                      :plaintext="togglePlaintext"
                      plaintext />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Matricula</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Matricula"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>
              
              <b-row class="justify-content-center">
                <b-col cols="1"></b-col>
                <b-col>
                  <b-button
                    variant="primary"
                    @click="showAutomaticAcces = !showAutomaticAcces">
                    {{
                      showAutomaticAcces
                        ? "Ocultar Datos Acceso Automático"
                        : "Mostrar Datos Acceso Automático"
                    }}
                  </b-button>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>

                </b-col>
                <b-col cols="1"></b-col>
              </b-row>
              

              <b-row class="justify-content-center">
                <b-col cols="1"> </b-col>
                <b-col v-show="showAutomaticAcces">
                 <b-form-group>
                    <h4>Horarios</h4>
                    <b-form-select size="lg" v-model="body.timetables" :options="timetableOptions"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col> </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row v-show="showAutomaticAcces">
                <b-col cols="1"></b-col>
                <b-col>
                  <h4>Puertas Permitidas</h4>
                  <b-input-group class="mb-1" style="max-width: 750px;">
                    <b-form-input id="filterInput" v-model="filter2" type="search" placeholder="Type to Search"
                      :disabled="disable" />
                  </b-input-group>
                  <div style="max-height: 200px; overflow-y: auto">
                    <b-table striped hover responsive small :items="items2" :fields="fields2" :filter="filter2"
                      :disabled="disable">
                      <template #cell(Active)="data">
                        <b-form-checkbox v-model="data.item.tempActive" switch size="lg" :disabled="disable" />
                      </template>
                    </b-table>
                  </div>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!--<b-row class="mt-3" v-show="showAutomaticAcces">
                <h4>Tarjetas</h4>
                <b-col class="text-right">
                  <b-button variant="success" @click="addCard" class="mb-1" :disabled="disable">
                    Añadir Tarjeta
                  </b-button>
                </b-col>
              </b-row>

              <b-table
                striped
                hover
                responsive
                class="position-relative"
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields1"
                v-show="showAutomaticAcces">
                <template #cell(actions)="data">
                  <b-button size="sm" variant="info" @click="openEditModal(data.item)" class="mr-1" :disabled="disable">
                    Editar
                  </b-button>
                </template>

                <template #cell(card_type)="data">
                   <b-badge :variant="activeLabel[1][data.item.card_type]"
                    class="d-inline-flex align-items-center gap-2 p-2 text-dark">
                    <img v-if="data.item.card_type === 'mifare'" :src="require('@/assets/images/icons/card.png')"
                      alt="MiFare" title="MiFare" style="height: 30px" />
                    <img v-else-if="data.item.card_type === 'carplate'" :src="require('@/assets/images/icons/car.png')"
                      alt="CarPlate" title="CarPlate" style="height: 30px" />
                    <span>
                      {{ activeLabel[0][data.item.card_type] }}
                    </span>
                  </b-badge>
                </template>

                <template #cell(active)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">
                    {{ data.value ? "true" : "false" }}
                  </b-badge>
                </template>
              </b-table>-->

              <!-- Modal de edición -->
              <!----><b-modal v-model="showEditModal" title="Editar Tarjeta" @ok="onModalOk" @hidenn="resetForm"
                ok-title="Guardar" cancel-title="Cancelar" :disabled="disable">
                <b-form @submit.prevent="submitForm">
                  <b-form-group label="Número Tarjeta">
                    <b-form-input v-model="selectedCard.card_number" required :disabled="disable" />
                  </b-form-group>
                  <b-form-group label="Tipo Tarjeta">
                    <b-form-select v-model="selectedCard.card_type" :options="cardTypeOptions" required
                      :disabled="disable" />
                  </b-form-group>
                  <b-form-group label="Activo">
                    <b-form-checkbox v-model="selectedCard.active">
                      {{ selectedCard.active ? "Sí" : "No" }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>

              <!-- Modal de edición -->
              <b-modal v-model="showCreateModal" title="Crear Tarjeta" @ok="handleCreateCard" ok-title="Guardar"
                cancel-title="Cancelar">
                <b-form @submit.prevent="handleCreateCard">
                  <b-form-group label="Número Tarjeta" label-for="card-number">
                    <b-form-input id="card-number" v-model="selectedCard.card_number"
                      :state="errors.card_number ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_number">
                      {{ errors.card_number }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Tipo Tarjeta" label-for="card-type">
                    <b-form-select id="card-type" v-model="selectedCard.card_type" :options="cardTypeOptions"
                      :state="errors.card_type ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_type">
                      {{ errors.card_type }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox v-model="selectedCard.active">Active</b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>

              <b-row class="justify-content-center">
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  @click.prevent="validationForm"
                  type="submit"
                  :disabled="disable">
                  <feather-icon
                    icon="SaveIcon"
                    class="mr-0 mr-sm-50"></feather-icon>
                  Actualizar Persona
                </b-button>
                <b-button
                  variant="outline-primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :to="{
                    name: 'persons',
                    params: { idEvent: body.fkid_mxs_event },
                  }">
                  <feather-icon
                    icon="ArrowLeftCircleIcon"
                    class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <feather-icon icon="LogInIcon" />
                <span>Accred. Acces</span>
              </template>

              <b-table
                striped
                hover
                responsive
                class="position-relative"
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields">
                <template #cell(StatusDescription)="data">
                  <b-badge
                    :variant="statusVariant(data.item.StatusDescription)">
                    {{ data.item.StatusDescription }}
                  </b-badge>
                </template>
                <template #cell(StatusDescription_Offline)="data">
                  <b-badge
                    :variant="
                      statusVariant(data.item.StatusDescription_Offline)
                    ">
                    {{ data.item.StatusDescription_Offline }}
                  </b-badge>
                </template>
              </b-table>

              <b-card-body
                class="d-flex justify-content-between flex-wrap pt-0">
                <b-form-group
                  label="Por página"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1">
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    inline
                    :options="pageOptions" />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-tab>
          </b-tabs>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardText,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BFormSelect,
  BCardBody,
  BPagination,
  BBadge,
  BFormInvalidFeedback,
  BFormValidFeedback,
  VBVisible,
  VBVisiblePlugin,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import router from "@/router";
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import { extend } from "vee-validate";
import { regex } from "vee-validate/dist/rules";
import { decryptString } from "@/libs/crypto";
import moment from "moment";
import vSelect from "vue-select";

extend("dni", {
  ...regex,
  params: ["lazy"],
  validate: (value) => {
    if (/^(\d{8})([A-Z])$/.test(value)) {
      if (
        "TRWAGMYFPDXBNJZSQVHLCKE".charAt(parseInt(value, 10) % 23) ===
        value.charAt(8)
      ) {
        return true;
      }
      return "The DOI letter is incorrect";
    }
    return "The DOI is not valid";
  },
});

export default {
  components: {
    BTable,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BRow,
    BCol,
    BFormSelect,
    BCardBody,
    BPagination,
    BBadge,
    BFormInvalidFeedback,
    BFormValidFeedback,
    ValidationProvider,
    ValidationObserver,

    flatPickr,
    vSelect,
  },
  computed: {
    statusVariant() {
      const statusColor = {
              OK: "light-success",
              OK_Exit: "light-warning",
              "OK_Exit+": "light-warning",
              OK_entered: "light-info",
              ERROR: "light-danger",
              "INCORRECTO No es válido realizar movimineto de salida": "light-danger",
              REPETIT: "light-danger",
              "Fecha de vencimiento fuera de plazo": "light-danger",
              "Fecha de fin de validez fuera de plazo": "light-danger",
              "Fecha de caducidad fuera de plazo": "light-danger",
              "No existe documento en detalle del evento": "light-danger",
              "En baja: Entrada a baja": "light-danger",
              "ERROR DNI ACREDITACIÓN duplicado": "light-danger",
              "ACREDITACIÓN Anulada": "light-danger",
              "DENEGADA ACREDITACIÓN": "light-danger",
            };
      return (status) => statusColor[status];
    },
    docStatusOptions() {
      this.docStatusSelected = this.docStatus = this.docStatus.map((t) => ({
        text: t,
        value: t,
      }));
      return this.docStatus;
    },
    configureDocStatus() {
      const docStatus = this.docStatusSelected.split(" - ");
      this.body.fkid_accreditation_status = docStatus[0];
      this.body.DocStatus = docStatus[1];
    },
    dooraccesoptions() {
      return this.dooracces.map((acc) => ({ text: acc, value: acc }));
    },
    configureComany() {
      const company = this.companySeleceted.split(" - ");
      console.log(company[1]);
      const idCompany = company[1].replace(/[()]/g, "");
      this.body.fkid_accreditation_company = idCompany;
      this.body.Empresa_nom = company[0];
    },
  },
  methods: {
     async validationForm() {
      try {
        const currentUserId = decryptString(localStorage.getItem("idUser")) || "unknown";

        const success = await this.$refs.simpleRules.validate();
        if (!success) return;

        // Actualizamos datos de la persona ANTES de la pregunta
        const [error, pkidOrMessage] = await this.onSubmit();
        if (error) {
          this.$bvToast.toast(String(pkidOrMessage), {
            title: "Error",
            variant: "danger",
            solid: true,
          });
          return; // si hay error, salimos
        }

        // Filtrar puertas que cambiaron
        const doorsToUpdate = this.items2
          .filter(d => d.tempActive !== d.wasActive)
          .map(d => ({
            pkid_door: d.pkid_door,
            Active: d.tempActive ? 1 : 0,
          }));

        if (doorsToUpdate.length > 0) {
          // Enviar userId aparte, junto con las puertas
          await axios.put(`/DoorByPerson/${pkidOrMessage}`, {
            userId: currentUserId,
            doors: doorsToUpdate
          });
        }

        this.isEditing = false;
        this.togglePlaintext = true;
        this.disable = true;
        this.$bvToast.toast("Visitante editado correctamente", {
          title: "Update",
          variant: "success",
          solid: true,
        });

        // Ahora ya tenemos los datos actualizados, mostramos pregunta
        const confirmed = await this.$bvModal.msgBoxConfirm(
          "Quieres actualizar los dispositivos de acceso?",
          {
            title: "Enviar Dispositius",
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: "Sí",
            cancelTitle: "No",
            cancelVariant: "secondary",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );

        if (confirmed) {
          // Actualización de credenciales
          const url = process.env.VUE_APP_URL_API_UPDATE_CREDENTIALS;
          await axios.post(url, { id: pkidOrMessage });


          this.$bvToast.toast("Post visitante enviado correctamente", {
            title: "Post enviado",
            variant: "info",
            solid: true,
          });


        }
      } catch (error) {
        console.error("Error en validationForm:", error);
        this.$bvToast.toast(error.response?.data?.error || "Error general", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async loadEmployeeCards() {
      try {
        if (!this.currentPkid) {
          throw new Error("No hay ID de person disponible");
        }

        const result = await axios.get("/getCardByUsuari", {
          params: {
            pkid_accreditation_document_detail: this.currentPkid,
          },
        });

        this.items = result.data.map((card) => ({
          pkidcard: card.pkidcard,
          Fkid_accreditation_document_detail:
            card.fkid_accreditation_document_detail,
          card_number: card.card_number,
          card_type: card.card_type,
          active: card.active,
          timestamp_modification: card.timestamp_modification,
          user_creation: card.user_creation,
          timestamp_creation: card.timestamp_creation,
          user_name: card.User_name
        }));
      } catch (error) {
        console.error(
          "Error detallado:",
          error.response?.data || error.message
        );
        this.$bvToast.toast(
          "Error al cargar tarjetas: " +
            (error.response?.data?.message || error.message),
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      }
    },

    async loadEmployeeDoors() {
      try {
        if (!this.currentPkid) {
          throw new Error("No hay ID de empleado disponible");
        }

        // 1. Obtener aforos permitidos para el usuario
        const aforosResponse = await axios.get(
          `/userAcces?userId=${this.body.ID_usuari_creacio}`
        );
        const aforosPermitidos = aforosResponse.data.map(
          (item) => item.ID_Aforo
        );

        // 2. Filtrar aforos activos
        const aforoResponse = await axios.get(`/aforo?Active=1`);
        const aforosFiltrados = aforoResponse.data.filter((aforo) =>
          aforosPermitidos.includes(aforo.ID_Aforo)
        );

        // 3. Obtener puertas para cada aforo
        const doorPromises = aforosFiltrados.map((aforo) =>
          axios
            .get(`/dooracces?ID_Aforo=${aforo.ID_Aforo}`)
            .then((res) => res.data.map((d) => d.AccesSCA || ""))
            .catch(() => [])
        );

        const doorDataArrays = await Promise.all(doorPromises);
        const puertasPermitidas = doorDataArrays.flat();

        // 4. Procesar códigos de puerta
        const codigosPermitidos = puertasPermitidas
          .filter((p) => p) // Filtrar valores nulos/vacíos
          .map((p) => p.split(","))
          .flat();

        // 5. Obtener accesos del empleado
        const accesosResponse = await axios.get(
          `/accred-sca-registry/${this.currentPkid}`
        );
        const data = accesosResponse.data || [];

        // 6. Filtrar puertas permitidas
        this.items2 = data
          .filter((item) => {
            if (!item.AccesSCA) return false;
            const codigosPuerta = item.AccesSCA.split(",");
            return codigosPuerta.some((codigo) =>
              codigosPermitidos.includes(codigo)
            );
          })
          .map((item) => ({
            ...item,
            tempActive: item.Active === 1,
          }));

        if (this.items2.length === 0) {
          console.warn("No se encontraron puertas asociadas.");
        }
      } catch (error) {
        this.$bvToast.toast("Error al cargar puertas: " + error.message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async message() {
      const error = await this.onSubmit();
      if (error[0]) {
        const variant = "danger";
        this.$bvToast.toast("" + error[1], {
          title: "Error",
          variant,
          solid: true,
        });
      } else if (!error[0]) {
        this.togglePlaintext = true;
        this.date = true;
        this.hiddenComponent = true;
        const variant = "success";
        this.$bvToast.toast("Personas editado correctamente", {
          title: "Update",
          variant,
          solid: true,
        });
      }
    },

    dateFormat(date) {
      const months = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ];
      const minutesArray = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      let normalDate = date.split("T").join(" ");
      normalDate = date.split("Z").join("");
      const d = new Date(normalDate);
      let minutes = d.getMinutes();
      if (minutesArray.includes(d.getMinutes().toString())) {
        minutes = "0" + d.getMinutes();
      }
      const finalDate =
        d.getDate() +
        " " +
        months[d.getMonth()] +
        " " +
        d.getFullYear() +
        " " +
        d.getHours() +
        ":" +
        minutes;
      return finalDate;
    },

    openEditModal(card) {
      this.selectedCard = {
        ...card,
        active: card.active === 1 || card.active === true,
      };
      this.showEditModal = true;
    },

    async onModalOk(bvModalEvt) {
    bvModalEvt.preventDefault(); 

    const success = await this.saveCard();

    if (success) {
      this.showEditModal = false; 
    }
  },

  async saveCard() {
    try {
      if (!this.selectedCard || !this.selectedCard.pkidcard) {
        throw new Error("No se ha seleccionado una tarjeta válida para editar");
      }

      await axios.put(`/cards/${this.selectedCard.pkidcard}`, {
        pkid_accreditation_document_detail:
          this.selectedCard.fkid_accreditation_document_detail,
        card_number: this.selectedCard.card_number,
        card_type: this.selectedCard.card_type,
        active: this.selectedCard.active,
        user_creation: decryptString(localStorage.getItem("idUser")),
      });

      const index = this.items.findIndex(
        (item) => item.pkidcard === this.selectedCard.pkidcard
      );
      if (index !== -1) {
        this.items.splice(index, 1, { ...this.selectedCard });
      }

      this.$bvToast.toast("Credencial actualizada correctamente", {
        title: "Éxito",
        variant: "success",
        solid: true,
      });

      await this.loadCards();
      return true;
    } catch (error) {
      const backendMessage =
        error.response?.data?.error || "Error al actualizar la credencial";

      this.$bvToast.toast(backendMessage, {
        title: "Error",
        variant: "danger",
        solid: true,
      });
      return false;
    }
  },


    async addCard() {
      try {
        this.selectedCard = {
          pkidcard: null,
          card_number: "",
          card_type: "",
          active: true,
          user_creation: "",
        };

        this.showCreateModal = true;
      } catch (error) {
        console.error("Error al intentar agregar credencial:", error);
        this.$bvToast.toast(error.message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    //abrir el modal para crear tarjetas
    async handleCreateCard(bvModalEvt) {
      bvModalEvt.preventDefault();

      // Limpiar errores previos
      this.errors.card_number = '';
      this.errors.card_type = '';

      let hasError = false;

      if (!this.selectedCard.card_number) {
        this.errors.card_number = 'El número de credencial es obligatorio';
        hasError = true;
      }

      if (!this.selectedCard.card_type) {
        this.errors.card_type = 'El tipo de credencial es obligatorio';
        hasError = true;
      }

      if (!this.$route.params.id) {
        this.$bvToast.toast("No se ha obtenido el ID del empleado", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }

      if (hasError) return; // Detener la función si hay errores

      try {
        const response = await axios.post("/cards", {
          pkidcard: this.selectedCard.pkidcard,
          card_number: this.selectedCard.card_number,
          card_type: this.selectedCard.card_type,
          active: this.selectedCard.active,
          fkid_accreditation_document_detail: this.$route.params.id,
          user_creation: decryptString(localStorage.getItem("idUser")),
        });

        await this.loadCards();

        this.$bvToast.toast("Tarjeta creada correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true,
        });

        this.showCreateModal = false;
        this.resetForm();
      } catch (error) {
        const msg =
          (error.response && error.response.data && error.response.data.error) ||
          "Error al intentar crear la credencial. Inténtalo de nuevo.";

        this.$bvToast.toast(msg, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    resetForm() {
      this.selectedCard = {
        pkidcard: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      };
    },

    //cargar las tarjetas
    async loadCards() {
      const pkid_accreditation_document_detail = this.$route.params.id;
      try {
        const result = await axios.get("/getCardByUsuari", {
          params: { pkid_accreditation_document_detail },
        });
        this.items = result.data.map((card) => ({
          pkidcard: card.pkidcard,
          Fkid_accreditation_document_detail:
            card.fkid_accreditation_document_detail,
          card_number: card.card_number,
          card_type: card.card_type,
          active: card.active,
          timestamp_modification: card.timestamp_modification,
          user_creation: card.user_creation,
          timestamp_creation: card.timestamp_creation,
        }));

        // Si hay datos, mostrar automáticamente la sección
        if (this.items.length > 0) {
          this.showAutomaticAcces = true;
        }

      } catch (error) {
        console.error("Error al cargar las tarjetas:", error);
      }
    },

    //funcion para activar o desactivar las puertas con el swtich
    async onToggleActive(item) {
      // Simplemente invierte el valor local
      item.tempActive = !item.tempActive;
    },
  },

  data() {
    return {
      dni: "",
      required,
      dateDisabled: false,
      togglePlaintext: false,
      docStatus: [],
      docStatusSelected: "",
      companySeleceted: "",
      dniOptions: [
        { text: "DNI", value: "DNI" },
        { text: "Other", value: "Other" },
      ],
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      totalRows: 1,
      currentPage: 1,
      fields: [
        { key: "pkid_accreditation_sca_registry", label: "Id" },
        { key: "timestamp_creacio", label: "Creación" },
        { key: "timestamp_pda", label: "PDA Tiempo" },
        { key: "source", label: "Origen." },
        { key: "ID_user", label: "ID Usuario" },
        { key: "way", label: "Vía" },
        { key: "DoorName", label: "Nombre Puerta" },
        { key: "fkid_accreditation", label: "Acreditación" },
        { key: "fkid_mxs_event", label: "Evento" },
        { key: "StatusDescription", label: "Estado" },
        { key: "StatusDescription_Offline", label: "Estado Sin Conexión" },
      ],
      fields1: [
        { key: "pkidcard", label: "ID" },
        { key: "card_number", label: "Número Tarjeta" },
        { key: "card_type", label: "Tipo Tarjeta" },
        { key: "active", label: "Activo", formatter: (value) => !!value },
        {
          key: "timestamp_modification",
          label: "Fecha Modificación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "user_name", label: "Usuari_Creacio" },
        {
          key: "timestamp_creation",
          label: "Fecha Creación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "actions", label: "Acciones" },
      ],
      fields2: [
        { key: "Active", label: "Estado" },
        { key: "Aforo_name", label: "Aforo" },
        { key: "Name", label: "Nombre Puerta" },
      ],
      errors: {
        card_number: '',
        card_type: '',
      },
      items: [],
      items1: [],
      items2: [],
      dooracces: [],
      companies: [],
      timetables: [],
      timetableOptions: [],
      showAutomaticAcces: false,
      isEditing: true,
      disable: false,
      filter2: "",
      showEditModal: false,
      showDeleteModal: false,
      showCreateModal: false,
      selectedCard: {
        pkidcard: null,
        fkid_accreditation_document_detail: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      },
      refreshInterval: null,
      pollInterval: 5000,
      cardTypeOptions: [
        { text: "MiFare", value: "mifare" },
        { text: "CarPlate", value: "carplate" },
      ],
      activeLabel: [
        {
          mifare: "-MiFare",
          carplate: "-CarPlate",
        },
        {
          mifare: "default",
          carplate: "default",
        },
      ],
    };
  },
  async created() {
    this.loadCards();
    const pkid_accreditation_document_detail = this.$route.params.id;

    await axios
      .get("/company")
      .then((results) => {
        results.data.forEach((element) => {
          this.companies.push(
            element.Name + " - (" + element.pkid_accreditation_company + ")"
          );
        });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    await axios
      .get("/docStatus")
      .then((results) => {
        results.data.forEach((element) => {
          this.docStatus.push(
            element.pkid_accreditation_status + " - " + element.Description
          );
        });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    await axios
      .get(
        "/accred-doc-detailed?pkid_accreditation_document_detail=" +
          router.currentRoute.params.id
      )
      .then((results) => {
        this.body = results.data[0];
        this.docStatusSelected =
          this.body.fkid_accreditation_status + " - " + this.body.DocStatus;
        this.companySeleceted =
          this.body.Empresa_nom +
          " - (" +
          this.body.fkid_accreditation_company +
          ")";

        if (this.body.fkid_timetable) {
          this.body.timetables = this.body.fkid_timetable;
        }

        const timecreate = this.body.timestamp_creacio;
        const timeModifiyed = this.body.timestamp_modificacio;

        const months = [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ];
        const c = new Date(timecreate);
        const m = new Date(timeModifiyed);
        let cminutes = c.getMinutes();
        if (c.getMinutes() === 0) {
          cminutes = "00";
        }
        let mminutes = m.getMinutes();
        if (c.getMinutes() === 0) {
          mminutes = "00";
        }
        const creacio =
          c.getDate() +
          " " +
          months[c.getMonth()] +
          " " +
          c.getFullYear() +
          " " +
          (c.getHours() - 1) +
          ":" +
          cminutes;
        const modificacio =
          m.getDate() +
          " " +
          months[m.getMonth()] +
          " " +
          m.getFullYear() +
          " " +
          (m.getHours() - 1) +
          ":" +
          mminutes;
        this.body.timestamp_creacio = creacio;
        this.body.timestamp_modificacio = modificacio;
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    axios
      .get("/getCardByUsuari", {
        params: {
          pkid_accreditation_document_detail:
            pkid_accreditation_document_detail,
        },
      })
      .then((result) => {
        const cards = result.data;
        if (cards.length > 0) {
          this.items = cards.map((card) => ({
            pkidcard: card.pkidcard,
            Fkid_accreditation_document_detail:
              card.fkid_accreditation_document_detail,
            card_number: card.card_number,
            card_type: card.card_type,
            active: card.active,
            timestamp_modification: card.timestamp_modification,
            user_creation: card.user_creation,
            timestamp_creation: card.timestamp_creation,
            user_name: card.User_name
          }));
        } else {
          console.error(
            "No se encontraron tarjetas para el pkid proporcionado."
          );
        }
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `Error: ${error}`,
          variant,
          solid: true,
        });
      });

    await axios
      .get(
        "/accred-sca-registrySE?fkid_accreditation=" +
          router.currentRoute.params.id
      )
      .then((results) => {
        this.items1 = results.data;
        this.totalRows = this.items1.length;

        if (this.items1.length === 0) {
        }
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `${error}`,
          variant,
          solid: true,
        });
      });

    ///FUncion para cargar el usuario antes de pasarlo a las puertas
    const currentUserRaw = localStorage.getItem("userData");

    if (!currentUserRaw) {
      console.error("No hay ningún 'userData' guardado en localStorage");
      return;
    }

    let currentUser;
    try {
      currentUser = JSON.parse(currentUserRaw);
    } catch (e) {
      console.error("Error parseando 'userData' desde localStorage:", e);
      return;
    }

    if (currentUser && (currentUser.ID_user || currentUser.ID_usuari)) {
      this.body.ID_usuari_creacio =
        currentUser.ID_user || currentUser.ID_usuari;
    } else {
      console.error("No se encontró el usuario autenticado válido.");
    }




    axios
      .get(`/userAcces?userId=${this.body.ID_usuari_creacio}`)
      .then((response) => {
        const aforosPermitidos = response.data.map((item) => item.ID_Aforo);

        // Obtener todos los aforos activos
        axios
          .get(`/aforo?Active=1`)
          .then((results) => {
            // Filtrar los aforos permitidos
            const aforosFiltrados = results.data.filter((element) =>
              aforosPermitidos.includes(element.ID_Aforo)
            );

            // Mapear los aforos filtrados
            this.aforos = aforosFiltrados.map(
              (element) => `${element.Aforo_name} - (${element.ID_Aforo})`
            );

            // Preparar IDs para enviar en una sola petición
            const ids = aforosFiltrados.map((aforo) => aforo.ID_Aforo).join(',');

            // Hacer una sola petición con todos los IDs
            axios
              .get(`/dooracces?ID_Aforo=${ids}`)
              .then((doorResults) => {
                // doorResults.data es un array con todas las puertas
                // Mapear las puertas AccesSCA
                this.dooracces = doorResults.data
                  .map((element) => element.AccesSCA)
                  .flat();
              })
              .catch((error) => {
                console.error("Error al obtener las puertas para los aforos", error);
                this.dooracces = [];
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar las puertas de acceso", {
                  title: "" + error,
                  variant,
                  solid: true,
                });
              });
          })
          .catch((error) => {
            const variant = "danger";
            this.$bvToast.toast("Fallo al conectar la fecha de aforo", {
              title: "" + error,
              variant,
              solid: true,
            });
          });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar la fecha de acceso del usuario", {
          title: "" + error,
          variant,
          solid: true,
        });
      });


    axios
      .get("/timetable")
      .then((response) => {
        const options = response.data.map((timetable) => ({
          value: timetable.pkid_timetable,
          text: `${timetable.name} - ${timetable.description}`,
        }));

        this.timetableOptions = [{ value: null, text: "" }, ...options];

        // Mostrar automáticamente si hay más de un elemento (excluyendo el "null")
        if (options.length > 0) {
          this.showAutomaticAcces = true;
        }
      })
      .catch((error) => {
        console.error("Error al cargar horarios", error);
        this.$bvToast.toast("Error al cargar los horarios", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      });


    axios
      .get(`/userAcces?userId=${decryptString(localStorage.getItem("idUser"))}`)
      .then((response) => {
        const aforosPermitidos = response.data.map((item) => item.ID_Aforo);

        return axios.get(`/aforo?Active=1`).then((results) => {
          const aforosFiltrados = results.data.filter((element) =>
            aforosPermitidos.includes(element.ID_Aforo)
          );

          // Aquí se hace una sola petición con todos los IDs separados por coma
          const ids = aforosFiltrados.map((aforo) => aforo.ID_Aforo).join(',');

          return axios.get(`/dooracces?ID_Aforo=${ids}`).then((doorResults) => {
            const puertasPermitidas = doorResults.data.map((element) => element.AccesSCA);
            return puertasPermitidas;
          });
        });
      })
      .then((puertasPermitidas) => {
        const codigosPermitidos = puertasPermitidas
          .map((p) => p.split(","))
          .flat();

        return axios
          .get(`/accred-sca-registry/${pkid_accreditation_document_detail}`)
          .then((result) => {
            const data = result.data;

            if (Array.isArray(data) && data.length > 0) {
              const puertasFiltradas = data.filter((item) => {
                const codigosPuerta = item.AccesSCA.split(",");
                return codigosPuerta.some((codigo) =>
                  codigosPermitidos.includes(codigo)
                );
              });

              this.items2 = puertasFiltradas.map((item) => ({
                ...item,
                tempActive: item.Active === 1,
              }));
              
              // Mostrar sección solo si hay al menos una puerta activa
                if (this.items2.some((item) => item.tempActive)) {
                  this.showAutomaticAcces = true;
                }
            } else {
              this.items2 = [];
              console.warn("No se encontraron resultados.");
            }
          });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Error al cargar datos: " + error, {
          title: "Error",
          variant,
          solid: true,
        });
      });

  },

  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }

    const detailId = this.$route.query.id;
    if (detailId) {
      this.currentPkid = detailId;
      this.fetchPersons(detailId);
      this.loadEmployeeCards();
      this.loadEmployeeDoors();
    } else {
    }
  },

  setup() {
    const userId = decryptString(localStorage.getItem("idUser")) || "unknown";

    const blankPersonData = {
      pkid_accreditation_document_detail: "",
      Temporada: "",
      accreditation_localitzador: "",
      metode_creacio: "",
      fkid_accreditation_process_type: "",
      fkid_mxs_event: "",
      event_name: "",
      Aforo_name: "",
      Matricula:"",
      email: "",
      ID_usuari_modificacio: userId,
      UploadFilename: "",
      Data_neixament: "",
      timestamp_creacio: "",
      timestamp_modificacio: "",
      timetables: null,
      ID_usuari_creacio: userId,
    };

    const body = ref(JSON.parse(JSON.stringify(blankPersonData)));

    const onSubmit = async () => {
      const onError = [false, ""];
      body.value.ID_usuari_modificacio =
        decryptString(localStorage.getItem("idUser")) || userId;

      try {
        await axios.put("/accred-doc-detailed", body.value);

        await axios.post("/insertTimetable", {
          fkid_accreditation_document_detail:
            body.value.pkid_accreditation_document_detail,
          fkid_timetable: body.value.timetables,
        });

        return [false, body.value.pkid_accreditation_document_detail];
      } catch (error) {
        onError[0] = true;
        if (error.response && error.response.data && error.response.data.Error) {
          onError[1] = error.response.data.Error; // Mensaje del backend
        } else {
          onError[1] = "Error inesperado. Verifica la conexión o los datos.";
        }

        return onError;
      }

      return onError;
    };

    return {
      body,
      onSubmit,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
